
import ListIngresos from './List'

const IngresosPage = () => {
  return (
    <>
      <ListIngresos />
    </>
  )
}

export default IngresosPage
